import { useState } from 'react'
import type { User } from '../../../utils/loginUtils'
import { getMessage } from '../../../utils/messageUtils'

interface UserPopupFormProps {
  currentUser: User
  creatingNew: boolean
  name: string
  setName: React.Dispatch<React.SetStateAction<string>>
  password: string
  setPassword: React.Dispatch<React.SetStateAction<string>>
  chatId: string
  setChatId: React.Dispatch<React.SetStateAction<string>>
  alerts: boolean
  setAlerts: React.Dispatch<React.SetStateAction<boolean>>
  admin: boolean
  setAdmin: React.Dispatch<React.SetStateAction<boolean>>
  isMobile: boolean
}

function UserPopupForm({
  currentUser,
  creatingNew,
  name,
  setName,
  password,
  setPassword,
  chatId,
  setChatId,
  alerts,
  setAlerts,
  admin,
  setAdmin,
  isMobile,
}: UserPopupFormProps) {
  const [showPassword, setShowPassword] = useState(false)

  const labelClass = `pop-up-form-label ${isMobile ? 'pop-up-form-label-mobile' : ''}`
  const fieldClass = `pop-up-form-field ${isMobile ? 'pop-up-form-field-mobile' : ''}`
  return (
    <div>
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('name')}:</span>
        <input
          className={fieldClass}
          type="text"
          placeholder={getMessage('user_name')}
          value={name}
          readOnly={!creatingNew} // Username can only be edited when creating a new user
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('user_password')}:</span>
        <div className="pop-up-form-password-wrapper">
          <input
            className={fieldClass}
            type={showPassword ? 'text' : 'password'}
            placeholder={getMessage('user_password')}
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="pop-up-form-password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            👁️
          </button>
        </div>
      </div>
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('user_chat_id')}:</span>
        <input
          className={fieldClass}
          type="text"
          placeholder={getMessage('user_chat_id')}
          value={chatId}
          onChange={e => setChatId(e.target.value)}
        />
      </div>
      <div className="pop-up-form-checks">
        <div
          className={`pop-up-form-row pop-up-form-checks-row ${isMobile ? 'pop-up-form-checks-row-mobile' : ''}`}
        >
          <label className={labelClass}>
            <input
              className="pop-up-form-checkbox"
              type="checkbox"
              checked={alerts}
              onChange={e => setAlerts(e.target.checked)}
            />{' '}
            {getMessage('user_alerts')}
          </label>
          {currentUser.admin === 1 && (
            <label className={labelClass}>
              <input
                className="pop-up-form-checkbox"
                type="checkbox"
                checked={admin}
                onChange={e => setAdmin(e.target.checked)}
              />{' '}
              {getMessage('user_admin')}
            </label>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserPopupForm
